<template>
  <v-app :dark="dark" :class="$store.state.auth.user ? '' : 'gradient'">
    <electron-bar v-if="isElectron" />
    <nav-bar v-if="$store.state.auth.user" />
    <v-content>
      <router-view/>
    </v-content>
    <v-footer inset class="footer">
      <v-flex text-xs-center>
        <span>
          <v-btn flat icon small @click="dark = !dark">
            <v-icon small>fal fa-{{darkIcon}}</v-icon>
          </v-btn>
        </span>
        <span>
          &copy; {{(new Date()).getFullYear()}} UWA Dental School
        </span>
        <report-dialog v-if="$store.state.auth.user" />
      </v-flex>
    </v-footer>
  </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
import navBar from './views/partials/nav-bar.vue';
import reportDialog from './views/partials/report-dialog.vue';
// import electronBar from './views/partials/electron-bar.vue';

export default {
  components: {
    navBar,
    reportDialog,
    electronBar: () => import(/* webpackChunkName: "electron" */ './views/partials/electron-bar.vue'),
  },
  data() {
    return {
      dark: `${localStorage.dark}` === 'true',
    };
  },
  computed: {
    isElectron() { return window.process && typeof (window.process.versions.electron) === 'string'; },
    darkIcon() {
      if (this.dark) return 'lightbulb-slash';
      if ((new Date()).getMonth() === 11) return 'lights-holiday';
      return 'lightbulb-on';
    },
  },
  methods: {
    ...mapMutations('heuristics', ['setCurrent']),
  },
  watch: {
    dark(v) { localStorage.dark = v; },
  },
};
</script>

<style lang="stylus" scoped>
.gradient >>> .v-content
    background -moz-linear-gradient(-45deg, #6791bf 0%, #796bb2 100%)
    background -webkit-linear-gradient(-45deg, #6791bf 0%,#796bb2 100%)
    background linear-gradient(135deg, #6791bf 0%,#796bb2 100%)

.th-link
  font-family 'Lato', sans-serif
  text-decoration none
  color black

.th-link:hover
  text-decoration underline

.footer >>> .v-btn {
  margin: 0 8px;
}

</style>

<style lang="stylus">
html
  width: 100vw
::-webkit-scrollbar
  width 14px

::-webkit-scrollbar-track
  display none

::-webkit-scrollbar-thumb
  width 14px
  background rgba(125, 125, 125, 0.5)

  :hover
    background rgba(125, 125, 125, 1)
  :window-inactive
    background rgba(125, 125, 125, 0.5)
</style>
